import { render, staticRenderFns } from "./DiagnosticLabTypeSelect.vue?vue&type=template&id=2e5ea885&"
import script from "./DiagnosticLabTypeSelect.vue?vue&type=script&lang=js&"
export * from "./DiagnosticLabTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports